export default "__VITE_ASSET__EB4bQ9d7__"